module.exports = "<div class=\"container\" style=\"margin:40px auto;\">\r\n\t<article class=\"product_box\" *ngFor=\"let product of products\">\r\n \t\t<img src=\"/assets/images/{{product.image_url}}\">\r\n\t    <div class=\"product_box_r\">\r\n\t     <h3>{{product.name}}</h3>\r\n\t     \t<em>{{product.tagline}}</em>\r\n\t        <p>{{product.description}}</p>\r\n\t    </div>\r\n\t</article>\r\n</div> "


//////////////////
// WEBPACK FOOTER
// ./src/app/products/products.tpl.html
// module id = 189
// module chunks = 1